import { render, staticRenderFns } from "./HomeValue.vue?vue&type=template&id=7c41f87b&scoped=true"
import script from "./HomeValue.vue?vue&type=script&lang=js"
export * from "./HomeValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c41f87b",
  null
  
)

export default component.exports